import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './navbar-search-form.scss.js';
import img$1 from '../../../../assets/images/close-icon.svg.js';
import img from '../../../../assets/images/search-icon.svg.js';
import img$2 from '../../../../assets/images/recent-searches.svg.js';
import { PredictiveSearchService } from '../../utilities/predictive-search/predictive-search.service.js';

const LS_RECENT_SEARCHES_KEY = 'cvt-recent-searches';
const MAX_RECENT_SEARCHES = 4;
const MAX_PREDICTIVE_RESULTS = 4;
const COMPONENT_NAME = 'search-block';
const PREDICTIVE_SEARCH_API = '/api/predictivesearch';
class SearchFormUpdated extends s {
    constructor() {
        super();
        this.rtl = false;
        this.enableTopResults = false;
        this.enableViewAllLink = false;
        this.enableHistory = false;
        this.queryValue = '';
        this.apiUrl = PREDICTIVE_SEARCH_API;
        this.language = 'en-US';
        this.categories = [];
        this.labelSearchPlaceholder = 'Search for products or categories';
        this.labelSearchButton = 'Search';
        this.labelTopResults = 'TOP RESULTS';
        this.labelProduct = 'Product';
        this.labelPage = 'Page';
        this.labelNoResultsPrefix = 'Your search for [search-term] didn’t return any results.';
        this.labelViewAllResults = 'View all results for';
        this.labelSearchExecuted = 'Search executed';
        this.labelSearchCleared = 'Search text cleared';
        this.labelResults = 'results found';
        this.searchPageUrl = '';
        this.hasValue = false;
        this.isFocused = false;
        this.isSearchFocused = false;
        this.isClearFocused = false;
        this.recentSearches = [];
        this.showRecentSearches = false;
        this.showPredictiveSearch = false;
        this.searchQuery = '';
        this.activeDescendantIndex = -1;
        this.statusMessage = '';
        this.resultCount = '';
        this.predictiveResults = [];
        this.topProduct = null;
        this.topContent = null;
        this.isLoading = false;
        this.hasError = false;
        this.showSkeleton = false;
        this.productTotal = 0;
        this.contentTotal = 0;
        this.showNoResults = false;
        this.inputEl = null;
        this.searchBtnEl = null;
        this.clearBtnEl = null;
        this.formEl = null;
        this.noResultsTimer = null;
        this.skeletonTimer = null;
        this.fetchDebounceTimer = null;
        // Event handlers
        this.handleInput = () => {
            var _a;
            const value = ((_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.value) || '';
            this.hasValue = value.length > 0;
            this.searchQuery = value.trim();
            this.activeDescendantIndex = -1; // Reset active descendant
            // Clear fetch debounce timer - cancel any pending fetch
            if (this.fetchDebounceTimer) {
                clearTimeout(this.fetchDebounceTimer);
                this.fetchDebounceTimer = null;
            }
            // Clear skeleton timer to reset the delay, but keep skeleton visible if already showing
            if (this.skeletonTimer) {
                clearTimeout(this.skeletonTimer);
                this.skeletonTimer = null;
            }
            // Clear existing timers
            if (this.noResultsTimer) {
                clearTimeout(this.noResultsTimer);
                this.noResultsTimer = null;
            }
            this.showNoResults = false;
            // Clear previous results immediately when user types
            this.predictiveResults = [];
            this.topProduct = null;
            this.topContent = null;
            this.productTotal = 0;
            this.contentTotal = 0;
            // Trigger a debounced API call for predictive search
            if (this.hasValue) {
                this.updateDropdownVisibility();
                // Debounce the fetch call - only call after user stops typing
                this.fetchDebounceTimer = setTimeout(() => {
                    this.fetchPredictiveResults();
                }, 300);
            }
            else {
                // Clear results if input is empty
                this.showSkeleton = false;
                this.isLoading = false;
                this.hasError = false;
                this.updateDropdownVisibility();
            }
        };
        this.handleInputFocus = () => {
            this.isFocused = true;
        };
        this.handleInputBlur = () => {
            this.isFocused = false;
        };
        this.handleInputKeydown = (e) => {
            // Determine which list is active
            const hasPredictiveResults = this.showPredictiveSearch && this.predictiveResults.length > 0;
            const hasRecentSearches = this.showRecentSearches && this.recentSearches.length > 0;
            if (!hasPredictiveResults && !hasRecentSearches)
                return;
            const listLength = hasPredictiveResults
                ? this.predictiveResults.length
                : this.recentSearches.length;
            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    this.handleArrowDown(listLength);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    this.handleArrowUp();
                    break;
                // Tab is NOT intercepted here - allow natural flow to Clear/Search buttons
                case 'Enter':
                    this.handleEnterKey(e, hasPredictiveResults, hasRecentSearches);
                    break;
                case 'Escape':
                    e.preventDefault();
                    this.closeDropdowns();
                    break;
            }
        };
        /**
         * Handle keyboard events on dropdown links (Escape to close, Shift+Tab to go back to list)
         */
        this.handleDropdownLinkKeydown = (e) => {
            var _a;
            if (e.key === 'Escape') {
                e.preventDefault();
                this.closeDropdowns();
                (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            if (e.key === 'Tab' && e.shiftKey) {
                this.handleShiftTabFromDropdownLink(e);
            }
        };
        /**
         * Handle keyboard events on Clear and Search buttons (Tab to dropdown, Escape to close)
         */
        this.handleSearchBoxButtonKeydown = (e) => {
            var _a;
            if (e.key === 'Escape') {
                e.preventDefault();
                this.closeDropdowns();
                (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            const isSearchButton = e.currentTarget.classList.contains('search-button');
            if (e.key === 'Tab' && !e.shiftKey && isSearchButton) {
                this.handleTabFromSearchButton(e);
            }
        };
        this.handleSearchFocus = () => {
            this.isSearchFocused = true;
        };
        this.handleSearchBlur = () => {
            this.isSearchFocused = false;
        };
        this.handleClearFocus = () => {
            this.isClearFocused = true;
        };
        this.handleClearBlur = () => {
            this.isClearFocused = false;
        };
        this.handleClearClick = (e) => {
            e.preventDefault();
            if (this.inputEl) {
                this.inputEl.value = '';
                this.hasValue = false;
                this.searchQuery = '';
                this.updateDropdownVisibility();
                this.inputEl.focus();
                // Announce to screen readers
                this.announceStatus(this.labelSearchCleared);
            }
            this.isClearFocused = false;
        };
        this.handleSubmit = (e) => {
            var _a, _b;
            e.preventDefault();
            const value = (_b = (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
            if (value.trim()) {
                this.saveRecentSearch(value.trim());
                globalThis.location.href = this.getSearchUrl(value.trim());
                this.dispatchEvent(new CustomEvent('search', { detail: { value } }));
                // Announce to screen readers
                this.announceStatus(`${this.labelSearchExecuted}: ${value.trim()}`);
            }
        };
        this.handleRecentSearchClick = (searchTerm) => {
            if (this.inputEl) {
                this.inputEl.value = searchTerm;
                this.hasValue = true;
            }
            this.showRecentSearches = false;
            // Redirect to search page with query parameter
            globalThis.location.href = this.getSearchUrl(searchTerm);
            this.dispatchEvent(new CustomEvent('search', { detail: { value: searchTerm } }));
        };
        this.renderInput = () => {
            // Only set aria-controls and aria-expanded when an interactive listbox exists
            const predictiveListVisible = this.showPredictiveSearch && this.predictiveResults.length > 0;
            const recentListVisible = this.showRecentSearches && this.recentSearches.length > 0;
            const hasInteractiveListbox = predictiveListVisible || recentListVisible;
            let ariaControls;
            if (predictiveListVisible) {
                ariaControls = 'predictive-search-list';
            }
            else if (recentListVisible) {
                ariaControls = 'recent-search-list';
            }
            const isExpanded = hasInteractiveListbox;
            // Determine aria-activedescendant value (only when listbox is expanded)
            let activeDescendantId = '';
            if (isExpanded && this.activeDescendantIndex >= 0) {
                if (predictiveListVisible) {
                    activeDescendantId = `predictive-option-${this.activeDescendantIndex}`;
                }
                else if (recentListVisible) {
                    activeDescendantId = `recent-option-${this.activeDescendantIndex}`;
                }
            }
            return $ `<label for="search-input" class="visually-hidden">${this.labelSearchPlaceholder}</label> <input id="search-input" type="text" placeholder="${this.labelSearchButton}" role="combobox" aria-autocomplete="list" aria-controls="${ariaControls !== null && ariaControls !== void 0 ? ariaControls : w}" aria-expanded="${String(isExpanded)}" aria-haspopup="listbox" aria-activedescendant="${activeDescendantId || w}" .value="${this.queryValue}" data-rtl="${String(this.rtl)}">`;
        };
        this.renderSearchButton = () => $ `<button type="submit" class="search-button" aria-label="${this.labelSearchPlaceholder}" data-value-present="${String(this.hasValue)}" @keydown="${this.handleSearchBoxButtonKeydown}"><span class="visually-hidden">${this.labelSearchButton}</span> <img src="${img}" alt="" aria-hidden="true"></button>`;
        this.handlePredictiveSearchClick = (searchTerm) => {
            if (this.inputEl) {
                this.inputEl.value = searchTerm;
                this.hasValue = true;
            }
            this.showPredictiveSearch = false;
            globalThis.location.href = this.getSearchUrl(searchTerm);
            this.dispatchEvent(new CustomEvent('search', { detail: { value: searchTerm } }));
        };
        this.handleViewAllClick = (e) => {
            e.preventDefault();
            const searchTerm = this.searchQuery.trim();
            if (searchTerm) {
                globalThis.location.href = this.getSearchUrl(searchTerm);
            }
            this.dispatchEvent(new CustomEvent('view-all-results', {
                detail: { query: this.searchQuery },
            }));
        };
        this.searchService = new PredictiveSearchService({
            apiUrl: this.apiUrl,
            language: this.language,
            categories: this.categories,
            maxResults: MAX_PREDICTIVE_RESULTS,
        });
    }
    firstUpdated() {
        this.cacheElements();
        this.attachStaticListeners();
        this.loadRecentSearches();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.searchService.destroy();
        // Cleanup no results timer
        if (this.noResultsTimer) {
            clearTimeout(this.noResultsTimer);
            this.noResultsTimer = null;
        }
        // Cleanup skeleton timer
        if (this.skeletonTimer) {
            clearTimeout(this.skeletonTimer);
            this.skeletonTimer = null;
        }
        // Cleanup fetch debounce timer
        if (this.fetchDebounceTimer) {
            clearTimeout(this.fetchDebounceTimer);
            this.fetchDebounceTimer = null;
        }
    }
    updated() {
        const newClear = this.renderRoot.querySelector('.clear-button');
        if (newClear !== this.clearBtnEl) {
            if (this.clearBtnEl) {
                this.detachClearListeners(this.clearBtnEl);
            }
            this.clearBtnEl = newClear;
            if (this.clearBtnEl) {
                this.attachClearListeners(this.clearBtnEl);
            }
        }
    }
    focusInput() {
        if (this.inputEl) {
            this.inputEl.focus();
        }
        else {
            // If input is not cached yet, try to find and focus it
            const input = this.renderRoot.querySelector('#search-input');
            if (input) {
                input.focus();
            }
        }
    }
    clearInput() {
        // Clear all timers
        if (this.fetchDebounceTimer) {
            clearTimeout(this.fetchDebounceTimer);
            this.fetchDebounceTimer = null;
        }
        if (this.skeletonTimer) {
            clearTimeout(this.skeletonTimer);
            this.skeletonTimer = null;
        }
        if (this.noResultsTimer) {
            clearTimeout(this.noResultsTimer);
            this.noResultsTimer = null;
        }
        // Clear input value
        if (this.inputEl) {
            this.inputEl.value = '';
        }
        // Reset all state
        this.hasValue = false;
        this.searchQuery = '';
        this.predictiveResults = [];
        this.topProduct = null;
        this.topContent = null;
        this.productTotal = 0;
        this.contentTotal = 0;
        this.showSkeleton = false;
        this.showNoResults = false;
        this.isLoading = false;
        this.hasError = false;
        this.activeDescendantIndex = -1;
        // Update dropdown visibility
        this.updateDropdownVisibility();
    }
    cacheElements() {
        this.inputEl =
            this.renderRoot.querySelector('#search-input');
        this.searchBtnEl =
            this.renderRoot.querySelector('.search-button');
        this.formEl = this.renderRoot.querySelector('form');
    }
    attachStaticListeners() {
        if (this.inputEl) {
            this.inputEl.addEventListener('input', this.handleInput);
            this.inputEl.addEventListener('focus', this.handleInputFocus);
            this.inputEl.addEventListener('blur', this.handleInputBlur);
            this.inputEl.addEventListener('keydown', this.handleInputKeydown);
        }
        if (this.searchBtnEl) {
            this.searchBtnEl.addEventListener('focus', this.handleSearchFocus);
            this.searchBtnEl.addEventListener('blur', this.handleSearchBlur);
        }
        if (this.formEl) {
            this.formEl.addEventListener('submit', this.handleSubmit);
        }
    }
    attachClearListeners(el) {
        el.addEventListener('click', this.handleClearClick);
        el.addEventListener('focus', this.handleClearFocus);
        el.addEventListener('blur', this.handleClearBlur);
    }
    detachClearListeners(el) {
        el.removeEventListener('click', this.handleClearClick);
        el.removeEventListener('focus', this.handleClearFocus);
        el.removeEventListener('blur', this.handleClearBlur);
    }
    handleArrowDown(listLength) {
        this.activeDescendantIndex = Math.min(this.activeDescendantIndex + 1, listLength - 1);
        // Focus stays on input; aria-activedescendant indicates active option to screen readers
    }
    handleArrowUp() {
        this.activeDescendantIndex = Math.max(this.activeDescendantIndex - 1, -1);
        // Focus stays on input; aria-activedescendant indicates active option to screen readers
    }
    handleEnterKey(e, hasPredictiveResults, hasRecentSearches) {
        if (this.activeDescendantIndex < 0)
            return;
        e.preventDefault();
        if (hasPredictiveResults) {
            this.handlePredictiveSearchClick(this.predictiveResults[this.activeDescendantIndex]);
        }
        else if (hasRecentSearches) {
            this.handleRecentSearchClick(this.recentSearches[this.activeDescendantIndex]);
        }
    }
    closeDropdowns() {
        this.showPredictiveSearch = false;
        this.showRecentSearches = false;
        this.activeDescendantIndex = -1;
    }
    /**
     * Get the ID prefix for option elements based on list type
     */
    getOptionIdPrefix(type) {
        return type === 'recent' ? 'recent-option' : 'predictive-option';
    }
    /**
     * Focus an option at a specific index
     */
    focusOptionAtIndex(index, type) {
        // Use requestAnimationFrame to ensure DOM has updated after state change
        requestAnimationFrame(() => {
            const prefix = this.getOptionIdPrefix(type);
            const item = this.renderRoot.querySelector(`#${prefix}-${index}`);
            if (item instanceof HTMLElement) {
                item.focus();
            }
        });
    }
    /**
     * Handle keyboard events for list options (Tab, Arrow keys, Enter, Space, Escape)
     */
    handleOptionKeydown(e, index, type, searchTerm) {
        var _a;
        const list = type === 'recent' ? this.recentSearches : this.predictiveResults;
        // Account for display limit - only MAX_PREDICTIVE_RESULTS items are shown
        const displayedCount = type === 'predictive'
            ? Math.min(list.length, MAX_PREDICTIVE_RESULTS)
            : Math.min(list.length, MAX_RECENT_SEARCHES);
        const maxIndex = displayedCount - 1;
        switch (e.key) {
            case 'Enter':
            case ' ':
                e.preventDefault();
                this.selectOption(type, searchTerm);
                break;
            case 'ArrowDown':
                e.preventDefault();
                this.navigateToNextOption(index, maxIndex, type);
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.navigateToPreviousOption(index, type);
                break;
            case 'Tab':
                this.handleTabInOption(e, index, maxIndex, type);
                break;
            case 'Escape':
                e.preventDefault();
                this.closeDropdowns();
                (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.focus();
                break;
        }
    }
    selectOption(type, searchTerm) {
        if (type === 'recent') {
            this.handleRecentSearchClick(searchTerm);
        }
        else {
            this.handlePredictiveSearchClick(searchTerm);
        }
    }
    navigateToNextOption(index, maxIndex, type) {
        if (index < maxIndex) {
            this.activeDescendantIndex = index + 1;
            this.focusOptionAtIndex(index + 1, type);
        }
    }
    navigateToPreviousOption(index, type) {
        var _a;
        if (index > 0) {
            this.activeDescendantIndex = index - 1;
            this.focusOptionAtIndex(index - 1, type);
        }
        else {
            // Return focus to input when at first item
            this.activeDescendantIndex = -1;
            (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
    handleTabInOption(e, index, maxIndex, type) {
        var _a;
        if (e.shiftKey) {
            // Shift+Tab: go to previous item or back to search button
            if (index > 0) {
                e.preventDefault();
                this.activeDescendantIndex = index - 1;
                this.focusOptionAtIndex(index - 1, type);
            }
            else {
                // At first item, go back to search button
                e.preventDefault();
                this.activeDescendantIndex = -1;
                (_a = this.searchBtnEl) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
        else if (index < maxIndex) {
            // Tab: go to next item
            e.preventDefault();
            this.activeDescendantIndex = index + 1;
            this.focusOptionAtIndex(index + 1, type);
        }
        else {
            // At last item: focus the top results links if available, otherwise let Tab flow naturally
            const nextElement = this.getNextFocusableDropdownElement();
            if (nextElement) {
                e.preventDefault();
                nextElement.focus();
            }
            // If no dropdown links, let Tab proceed naturally
        }
    }
    /**
     * Get the next focusable element after the list items (e.g., top result links, view all link)
     * Returns null if no focusable elements found
     */
    getNextFocusableDropdownElement() {
        const dropdown = this.renderRoot.querySelector('.predictive-search-dropdown, .recent-searches-dropdown');
        if (!dropdown)
            return null;
        // Look for result links and view-all link specifically
        const focusableElements = dropdown.querySelectorAll('.result-link, .view-all-link');
        // Return the first one found
        if (focusableElements.length > 0) {
            return focusableElements[0];
        }
        return null;
    }
    /**
     * Get the displayed count for a list type (accounts for MAX limits)
     */
    getDisplayedCount(listType) {
        const list = listType === 'predictive' ? this.predictiveResults : this.recentSearches;
        const maxLimit = listType === 'predictive' ? MAX_PREDICTIVE_RESULTS : MAX_RECENT_SEARCHES;
        return Math.min(list.length, maxLimit);
    }
    /**
     * Handle Shift+Tab from a dropdown link - go back to last list item or search button
     */
    handleShiftTabFromDropdownLink(e) {
        var _a;
        const currentTarget = e.currentTarget;
        const firstDropdownLink = this.getNextFocusableDropdownElement();
        if (currentTarget !== firstDropdownLink) {
            // Not the first link, let Tab flow naturally to previous link
            return;
        }
        // This is the first dropdown link, go back to last list item
        e.preventDefault();
        const listType = this.showPredictiveSearch ? 'predictive' : 'recent';
        const maxDisplayed = this.getDisplayedCount(listType);
        if (maxDisplayed > 0) {
            this.activeDescendantIndex = maxDisplayed - 1;
            this.focusOptionAtIndex(maxDisplayed - 1, listType);
        }
        else {
            (_a = this.searchBtnEl) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
    /**
     * Handle Tab from Search button - go to first dropdown item if dropdown is open
     */
    handleTabFromSearchButton(e) {
        const hasDropdown = this.showPredictiveSearch || this.showRecentSearches;
        if (!hasDropdown)
            return;
        const listType = this.showPredictiveSearch ? 'predictive' : 'recent';
        const maxDisplayed = this.getDisplayedCount(listType);
        if (maxDisplayed > 0) {
            e.preventDefault();
            this.activeDescendantIndex = 0;
            this.focusOptionAtIndex(0, listType);
        }
    }
    updateDropdownVisibility() {
        // Show predictive search if:
        // 1. There's a value, and predictive results exist, OR
        // 2. There's a value but no results (to show the "No suggestions found" message), OR
        // 3. There's an error, OR
        // 4. It's loading
        this.showPredictiveSearch =
            (this.hasValue && this.predictiveResults.length > 0) ||
                (this.hasValue &&
                    this.predictiveResults.length === 0 &&
                    !this.isLoading) ||
                this.hasError ||
                this.isLoading;
        // Show recent searches if the input is empty and there are recent searches
        this.showRecentSearches = this.recentSearches.length > 0 && !this.hasValue;
        // Reset the active descendant index if there are no interactive options
        if (!this.hasInteractiveListbox()) {
            this.activeDescendantIndex = -1;
        }
        // Update result count for screen readers
        if (this.showPredictiveSearch && this.predictiveResults.length > 0) {
            const count = Math.min(this.predictiveResults.length, MAX_PREDICTIVE_RESULTS);
            this.resultCount = `${count} ${this.labelResults}`;
        }
        else if (!this.hasValue && this.searchQuery) {
            this.resultCount = '';
        }
        else {
            this.resultCount = '';
        }
    }
    // Recent searches methods
    loadRecentSearches() {
        try {
            const stored = localStorage.getItem(LS_RECENT_SEARCHES_KEY);
            if (stored) {
                this.recentSearches = JSON.parse(stored);
                this.updateDropdownVisibility();
            }
        }
        catch (error) {
            this.recentSearches = [];
            console.warn('Failed to load recent searches from localStorage:', error);
        }
    }
    saveRecentSearch(searchTerm) {
        // Don't add empty or duplicate searches
        if (!searchTerm || this.recentSearches.includes(searchTerm)) {
            return;
        }
        // Add to the beginning of an array
        this.recentSearches = [searchTerm, ...this.recentSearches];
        // Keep only the most recent searches
        if (this.recentSearches.length > MAX_RECENT_SEARCHES) {
            this.recentSearches = this.recentSearches.slice(0, MAX_RECENT_SEARCHES);
        }
        // Save to localStorage
        try {
            localStorage.setItem(LS_RECENT_SEARCHES_KEY, JSON.stringify(this.recentSearches));
        }
        catch (error) {
            console.warn('Failed to save recent searches to localStorage:', error);
        }
        this.updateDropdownVisibility();
    }
    announceStatus(message) {
        this.statusMessage = message;
        // Clear after 3 seconds
        setTimeout(() => {
            this.statusMessage = '';
        }, 3000);
    }
    /**
     * Strip HTML tags from text for accessibility
     */
    stripHtmlTags(htmlString) {
        const temp = document.createElement('div');
        temp.innerHTML = htmlString;
        return temp.textContent || temp.innerText || '';
    }
    getSearchUrl(searchTerm) {
        if (!this.searchPageUrl || this.searchPageUrl.trim() === '') {
            return '#';
        }
        return `${this.searchPageUrl}?q=${encodeURIComponent(searchTerm)}`;
    }
    /**
     * Strip HTML tags from text for accessibility
     */
    async fetchPredictiveResults() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.searchQuery) {
            this.predictiveResults = [];
            this.topProduct = null;
            this.topContent = null;
            this.productTotal = 0;
            this.contentTotal = 0;
            this.showNoResults = false;
            this.isLoading = false;
            this.hasError = false;
            this.showSkeleton = false;
            return;
        }
        // Store the current query to detect stale responses
        const currentQuery = this.searchQuery;
        // Update service configuration if properties changed
        this.searchService.updateConfig({
            apiUrl: this.apiUrl,
            language: this.language,
            categories: this.categories,
            maxResults: MAX_PREDICTIVE_RESULTS,
        });
        try {
            this.isLoading = true;
            this.hasError = false;
            this.showNoResults = false;
            // Show skeleton after a short delay (when user stops typing and request is in progress)
            this.skeletonTimer = setTimeout(() => {
                if (this.isLoading) {
                    this.showSkeleton = true;
                }
            }, 300);
            // Get a full API response with autocomplete, products, and content
            const response = await this.searchService.debouncedSearch(this.searchQuery);
            // Ignore stale responses - only process if this is still the current search
            if (currentQuery !== this.searchQuery) {
                return;
            }
            // Clear skeleton timer and hide skeleton once results arrive
            if (this.skeletonTimer) {
                clearTimeout(this.skeletonTimer);
                this.skeletonTimer = null;
            }
            this.showSkeleton = false;
            this.predictiveResults = response.autoCompleteSuggestions || [];
            this.topProduct = ((_b = (_a = response.productResult) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) || null;
            this.topContent = ((_d = (_c = response.contentResult) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d[0]) || null;
            this.productTotal = ((_e = response.productResult) === null || _e === void 0 ? void 0 : _e.total) || 0;
            this.contentTotal = ((_f = response.contentResult) === null || _f === void 0 ? void 0 : _f.total) || 0;
            this.hasError = false;
            this.updateDropdownVisibility();
            const hasNoResults = this.predictiveResults.length === 0 &&
                !this.topProduct &&
                !this.topContent;
            // Show no results immediately after API returns (no delay needed)
            this.showNoResults = hasNoResults;
            // Clear any existing no results timer
            if (this.noResultsTimer) {
                clearTimeout(this.noResultsTimer);
                this.noResultsTimer = null;
            }
            // Announce search executed and results to screen readers
            this.announceStatus(`${this.labelSearchExecuted}: ${this.searchQuery}`);
            if (this.predictiveResults.length > 0) {
                setTimeout(() => {
                    this.announceStatus(`${this.predictiveResults.length} ${this.labelResults}`);
                }, 500);
            }
        }
        catch (error) {
            console.error('Error fetching predictive search results:', error);
            // Clear skeleton timer on error
            if (this.skeletonTimer) {
                clearTimeout(this.skeletonTimer);
                this.skeletonTimer = null;
            }
            this.showSkeleton = false;
            this.hasError = true;
            this.predictiveResults = [];
            this.topProduct = null;
            this.topContent = null;
            this.productTotal = 0;
            this.contentTotal = 0;
            this.showNoResults = false;
            this.updateDropdownVisibility();
        }
        finally {
            this.isLoading = false;
        }
    }
    get showDivider() {
        return this.hasValue || this.isSearchFocused || this.isClearFocused;
    }
    renderClearButton() {
        if (!this.hasValue)
            return '';
        return $ `<button type="button" class="clear-button" aria-label="Clear search text" @keydown="${this.handleSearchBoxButtonKeydown}"><span class="visually-hidden">Clear</span> <img src="${img$1}" alt="" aria-hidden="true"></button>`;
    }
    renderDivider() {
        return this.showDivider ? $ `<div class="divider"></div>` : '';
    }
    /**
     * Check if there are interactive predictive search options
     */
    hasInteractivePredictiveOptions() {
        return this.predictiveResults.length > 0;
    }
    /**
     * Check if there are interactive recent search options
     */
    hasInteractiveRecentOptions() {
        return this.recentSearches.length > 0;
    }
    /**
     * Check if any interactive listbox is present
     */
    hasInteractiveListbox() {
        if (this.showPredictiveSearch && this.hasInteractivePredictiveOptions()) {
            return true;
        }
        return this.showRecentSearches && this.hasInteractiveRecentOptions();
    }
    renderRecentSearchItem(searchTerm, index) {
        const isActive = this.activeDescendantIndex === index;
        return $ `<li id="recent-option-${index}" class="recent-search-item ${this.rtl ? 'rtl' : ''} ${isActive
            ? 'active'
            : ''}" role="option" tabindex="0" aria-selected="${String(isActive)}" @click="${() => this.handleRecentSearchClick(searchTerm)}" @keydown="${(e) => this.handleOptionKeydown(e, index, 'recent', searchTerm)}" @focus="${() => {
            this.activeDescendantIndex = index;
        }}"><img src="${img$2}" alt="" class="recent-search-icon" aria-hidden="true"> <span>${searchTerm}</span></li>`;
    }
    renderRecentSearches() {
        if (!this.enableHistory)
            return '';
        if (!this.showRecentSearches || this.recentSearches.length === 0) {
            return '';
        }
        return $ `<div class="recent-searches-dropdown"><ul id="recent-search-list" class="recent-searches-list" role="listbox" aria-label="Recent searches">${this.recentSearches.map((searchTerm, index) => this.renderRecentSearchItem(searchTerm, index))}</ul></div>`;
    }
    // Predictive search methods
    highlightSearchTerm(text) {
        if (!this.searchQuery) {
            return $ `<span>${text}</span>`;
        }
        const query = this.searchQuery.toLowerCase();
        const textLower = text.toLowerCase();
        const index = textLower.indexOf(query);
        if (index === -1) {
            return $ `<span>${text}</span>`;
        }
        const before = text.substring(0, index);
        const match = text.substring(index, index + this.searchQuery.length);
        const after = text.substring(index + this.searchQuery.length);
        return $ `<span>${before}<strong>${match}</strong>${after}</span>`;
    }
    renderPredictiveSearchItem(searchTerm, index) {
        const isActive = this.activeDescendantIndex === index;
        return $ `<li id="predictive-option-${index}" class="predictive-search-item ${this.rtl ? 'rtl' : ''} ${isActive
            ? 'active'
            : ''}" role="option" tabindex="0" aria-selected="${String(isActive)}" @click="${() => this.handlePredictiveSearchClick(searchTerm)}" @keydown="${(e) => this.handleOptionKeydown(e, index, 'predictive', searchTerm)}" @focus="${() => {
            this.activeDescendantIndex = index;
        }}">${this.highlightSearchTerm(searchTerm)}</li>`;
    }
    renderTopProductResult() {
        if (!this.topProduct)
            return '';
        return $ `<div class="top-result-item"><div class="result-content"><span class="result-type-label">${this.labelProduct}</span> <a href="${this.topProduct.url}" class="result-link" title="${this.labelProduct}: ${this.stripHtmlTags(this.topProduct.title)}" aria-label="${this.labelProduct}: ${this.stripHtmlTags(this.topProduct.title)}" @click="${() => {
            this.showPredictiveSearch = false;
        }}" @keydown="${this.handleDropdownLinkKeydown}">${o(this.topProduct.title)}</a></div></div>`;
    }
    renderTopContentResult() {
        if (!this.topContent)
            return '';
        return $ `<div class="top-result-item"><div class="result-content"><span class="result-type-label">${this.labelPage}</span> <a href="${this.topContent.url}" class="result-link" title="${this.labelPage}: ${this.stripHtmlTags(this.topContent.title)}" aria-label="${this.labelPage}: ${this.stripHtmlTags(this.topContent.title)}" @click="${() => {
            this.showPredictiveSearch = false;
        }}" @keydown="${this.handleDropdownLinkKeydown}">${o(this.topContent.title)}</a></div></div>`;
    }
    renderSkeleton() {
        return $ `<div class="skeleton-container"><div class="top-result-item skeleton"><div class="result-content"><div class="skeleton-eyebrow"></div><div class="skeleton-title"></div></div></div></div>`;
    }
    renderTopResultsSection() {
        // Don't show if there's no search query
        if (!this.hasValue || !this.enableTopResults)
            return '';
        // Determine if we should show the border (only when there are predictive results)
        const hasPredictiveResults = this.predictiveResults.length > 0;
        const borderClass = hasPredictiveResults ? 'with-border' : '';
        // Always show the container when the user is typing, even if no results
        return $ `<div class="top-results-container"><div class="top-results-section ${borderClass}"><div class="top-results-label">${this.labelTopResults.toUpperCase()}</div></div>${this.renderTopProductResult()} ${this.renderTopContentResult()}</div>`;
    }
    renderPredictiveSearchList(displayResults) {
        if (displayResults.length === 0)
            return '';
        return $ `<ul id="predictive-search-list" class="predictive-search-list" role="listbox" aria-label="Search suggestions">${displayResults.map((searchTerm, index) => this.renderPredictiveSearchItem(searchTerm, index))}</ul>`;
    }
    renderViewAllLink() {
        if (!this.enableViewAllLink)
            return '';
        const totalResults = this.productTotal + this.contentTotal;
        const resultCountText = totalResults > 0 ? ` - (${totalResults})` : '';
        return $ `<div class="view-all-container"><a href="#" class="view-all-link" @click="${this.handleViewAllClick}" aria-label="${this.labelViewAllResults} ${this.searchQuery}">${this.labelViewAllResults} <strong>"${this.searchQuery}"${resultCountText}</strong></a></div>`;
    }
    renderPredictiveSearch() {
        if (!this.showPredictiveSearch) {
            return '';
        }
        // Show "No results" message only if not loading and skeleton is not showing
        if (this.showNoResults &&
            this.hasValue &&
            !this.isLoading &&
            !this.showSkeleton &&
            this.enableTopResults) {
            const highlighted = `<strong>${this.searchQuery}</strong>`;
            const message = this.labelNoResultsPrefix.replace('[search-term]', highlighted);
            return $ `<div class="no-results-container"><div class="no-results-text" role="status" aria-live="polite">${o(message)}</div></div>`;
        }
        if (this.predictiveResults.length === 0 &&
            !this.topProduct &&
            !this.topContent) {
            return '';
        }
        // Limit to maximum 4 results
        const displayResults = this.predictiveResults.slice(0, MAX_PREDICTIVE_RESULTS);
        return $ `<div class="predictive-search-dropdown">${this.renderPredictiveSearchList(displayResults)} ${this.renderTopResultsSection()} ${this.renderViewAllLink()}</div>`;
    }
    render() {
        const classes = [
            'search-box',
            this.isFocused ? 'focused' : '',
            this.hasValue ? 'has-value' : '',
            this.rtl ? 'rtl' : '',
        ]
            .filter(Boolean)
            .join(' ');
        return $ `<div class="combobox-container" data-component="${COMPONENT_NAME}"><div id="status-message" class="visually-hidden" aria-live="polite" aria-atomic="true">${this.statusMessage}</div><div id="result-count" class="visually-hidden" aria-live="polite" aria-atomic="true">${this.resultCount}</div><form role="search"><div class="input-wrapper"><div class="${classes}">${this.renderInput()} ${this.renderClearButton()} ${this.renderDivider()} ${this.renderSearchButton()}</div>${this.showSkeleton ? this.renderSkeleton() : ''} ${this.renderRecentSearches()} ${this.renderPredictiveSearch()}</div></form></div>`;
    }
}
SearchFormUpdated.styles = css_248z;
__decorate([
    e({ type: Boolean, reflect: true })
], SearchFormUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], SearchFormUpdated.prototype, "enableTopResults", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], SearchFormUpdated.prototype, "enableViewAllLink", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], SearchFormUpdated.prototype, "enableHistory", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "queryValue", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "apiUrl", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "language", void 0);
__decorate([
    e({ type: Array })
], SearchFormUpdated.prototype, "categories", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelSearchPlaceholder", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelSearchButton", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelTopResults", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelProduct", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelPage", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelNoResultsPrefix", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelViewAllResults", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelSearchExecuted", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelSearchCleared", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "labelResults", void 0);
__decorate([
    e({ type: String })
], SearchFormUpdated.prototype, "searchPageUrl", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "hasValue", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "isFocused", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "isSearchFocused", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "isClearFocused", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "recentSearches", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "showRecentSearches", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "showPredictiveSearch", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "searchQuery", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "activeDescendantIndex", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "statusMessage", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "resultCount", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "predictiveResults", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "topProduct", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "topContent", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "isLoading", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "hasError", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "showSkeleton", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "productTotal", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "contentTotal", void 0);
__decorate([
    t()
], SearchFormUpdated.prototype, "showNoResults", void 0);
customElements.define('navbar-search-form', SearchFormUpdated);

export { SearchFormUpdated };
